import { useRoomBookingTimeslot } from "@lib/logic";
import { getSuggestionDataForRoomIdForRequest, type MeetingRoom, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";
import { MeetingRoomDetailsCardBottom } from "@organisms";

import { useRoomsRequest } from "../../rooms/useRoomsRequest";
import { PanelStackContext } from "../../shared/PanelStack/PanelStackContext";
import { HaNContext } from "../../shell/HaNContext";
import { minuteClock } from "../../state/refresh/refreshClock";
import { useCompleteRoomBooking } from "./useCompleteRoomBooking";

// Books the room now with one press, or opens the booking details to add a title, invitees and a message first
export const RoomDetailsFooter = ({ room }: { room: MeetingRoom }) => {
  const { rooms } = useRequiredContext(HaNContext);
  const { push } = useRequiredContext(PanelStackContext);
  const request = useRoomsRequest();
  const meetingRoomSuggestion = useAppSelector(state => getSuggestionDataForRoomIdForRequest(state, request, room.id));
  const timeslot = useRoomBookingTimeslot({
    minuteClock,
    request,
    roomId: room.id,
    durationMinutes: rooms.duration,
  });
  const completeRoomBooking = useCompleteRoomBooking();

  return (
    <MeetingRoomDetailsCardBottom
      room={room}
      dynamicTimeslot={timeslot}
      meetingRoomSuggestion={meetingRoomSuggestion}
      onBookingDetailsPress={() => push("booking")}
      onBookNowCallback={() => completeRoomBooking(room.id)}
    />
  );
};
